import Vue from 'vue'
import App from './App.vue'
import router from '@/router'

// import "../src/scss/custom.scss"
// import "../src/scss/app.scss"

Vue.config.productionTip = false

/* eslint-disable */
window.bootstrapApp = new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
